import { GateTypes } from '@/types/registration.types';

/**
 * Collapses a (possibly multi-gate, legacy) selection down to brandlive-platform's single active
 * gate when the user toggles a gate in the panel. brandlive-platform persists only one gate at a
 * time, so the first manual edit commits to one:
 *  - turning a gate ON  -> that gate becomes the sole active gate (mutually exclusive).
 *  - turning a gate OFF -> keep the highest-precedence remaining gate (the survivor), or `null`
 *    ("open") if it was the last one. `activeGates` is ordered by precedence, so the first
 *    remaining entry is the survivor.
 */
export default function resolveGateToggle(activeGates: GateTypes[], gate: GateTypes, on: boolean): GateTypes | null {
  if (on) return gate;
  return activeGates.filter((g) => g !== gate)[0] ?? null;
}
